export const STATUS_META = {
  received: { label: "Received", color: "#3B82F6", bg: "rgba(59,130,246,0.12)" },
  searching: { label: "Searching", color: "#F59E0B", bg: "rgba(245,158,11,0.12)" },
  replied: { label: "Replied", color: "#10B981", bg: "rgba(16,185,129,0.12)" },
  not_found: { label: "Not Found", color: "#EF4444", bg: "rgba(239,68,68,0.12)" },
};

export const CASE_STATUSES = ["Active", "Pending Judgment", "Disposed", "Adjourned", "Reserved"];

export const SAMPLE_PRESETS = [
  { label: "CIV-2026-8890", msg: "Hi, please share details for case CIV-2026-8890" },
  { label: "MUM-HC-4021", msg: "Need an update on MUM-HC-4021" },
  { label: "DL-SC-9012", msg: "Case DL-SC-9012 status?" },
  { label: "Unknown case", msg: "Any update on XYZ-0000-0000 ?" },
];
